import React from 'react'

const StatusMessage = ({ message, buttonText, buttonClick }) => {
  return (
    <div className="status-board">
        <p className='message'>{ message }</p>
        <button onClick={ buttonClick }>{ buttonText }</button>
    </div>
  )
}

export default StatusMessage